import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2f1a7a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "area",
  class: "mx-2 mt-4"
}
const _hoisted_2 = { class: "note-box border-2 rounded bg-white border-gray-300 text-gray-800 dark:border-dark-400 dark:bg-dark-500 dark:text-dark-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons mr-2 float-left" }, " import_contacts ", -1))
const _hoisted_4 = { class: "dropdown relative" }
const _hoisted_5 = {
  class: "border py-0 pl-3 pr-2 items-center rounded focus:outline-none bg-white border-gray-500 text-gray-800 dark:bg-dark-10 dark:border-dark-10 dark:text-dark-text",
  style: {"width":"8rem"}
}
const _hoisted_6 = {
  class: "mr-1",
  style: {"float":"left"}
}
const _hoisted_7 = {
  class: "fill-current h-4 w-4",
  style: {"float":"right","margin-top":"4px"},
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "dropdown-menu absolute hidden shadow-xl z-10" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "bottom" }
const _hoisted_13 = ["id"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preList, (commentary, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: _ctx.problemId + 'pre' + index,
        class: "prenote"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["bg-gray-200 dark:bg-dark-400", _ctx.isLightMode() ? 'top' : 'top-dark'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.isLightMode() ? 'top_in_hide' : 'top_in_hide-dark'])
            }, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.topicCommentary')) + ": " + _toDisplayString(_ctx.getTitle(_ctx.type)) + " ", 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.preSelect), 1),
                  (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
                ]),
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preList, (f, l_index) => {
                    return (_openBlock(), _createElementBlock("li", { key: l_index }, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["py-1 px-3 min-w-full block whitespace-no-wrap text-left focus:outline-none notranslate border-r border-l bg-white hover:bg-gray-400 text-gray-800 dark:bg-dark-10 dark:text-dark-text dark:hover:bg-dark-200 dark:border-dark-200", {
                      'list-round-first border-t': l_index == 0,
                      'list-round-last border-b': l_index == _ctx.preList.length - 1
                    }]),
                        onClick: ($event: any) => (_ctx.get_commentary(commentary))
                      }, _toDisplayString(f), 11, _hoisted_11)
                    ]))
                  }), 128))
                ])
              ])
            ], 2)
          ], 2),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              id: _ctx.class_binder(commentary),
              class: _normalizeClass(["commentary mb-3", _ctx.isLightMode() ? 'description' : 'description-dark'])
            }, null, 10, _hoisted_13),
            _hoisted_14
          ])
        ])
      ]))
    }), 128))
  ]))
}